/* eslint-disable */
import React, { Component, createRef } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import OwlCarousel from "react-owl-carousel2";
import "../../common/css/owl.carousel.css";

import banner from "../../common/images/img/banner.jpg";
import banner1 from "../../common/images/img/banner1.jpg";
import dineicon from "../../common/images/dine-in-icon.svg";
import reservation from "../../common/images/reservation-icon.svg";
import gallerybig from "../../common/images/img/gallery.jpg";
import gallerythumb from "../../common/images/img/gallery1.jpg";
import gallerythumb1 from "../../common/images/img/gallery2.jpg";
import quote from "../../common/images/img/quote.svg";

import abt from "../../common/images/img/abt-img.png";
import searchi from "../../common/images/img/search-black.svg";
import ban from "../../common/images/img/deliv-ban.jpg";
import { ReactComponent as Selficon } from "../../common/images/self-pickup.svg";
import { ReactComponent as Cycle } from "../../common/images/cycle.svg";
import { format } from "date-fns";
import {
  apiUrl,
  uniqueID,
  deliveryId,
  pickupId,
  placeholderImage,
  appName,
} from "../Settings/Config";

import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import {
  showPriceDirect,
} from "../Settings/SettingHelper";

var mainbanner = {
  items: 1,
  loop: true,
  dots: true,
  nav: false,
  margin: 0,
};
var dishslider = {
  items: 4,
  loop: false,
  dots: true,
  nav: false,
  margin: 0,
  responsive: {
    0: {
      items: 1,
    },
    420: {
      items: 2,
    },
    780: {
      items: 2,
    },
    920: {
      items: 4,
    },
  },
};
var gallery = {
  items: 1,
  loop: true,
  dots: true,
  nav: false,
};
var reviewslider = {
  items: 1,
  loop: true,
  dots: true,
  nav: false,
};
var newdishslider = {
  items: 4,
  loop: false,
  dots: true,
  nav: false,
  margin: 0,
  responsive: {
    0: {
      items: 1,
    },
    420: {
      items: 2,
    },
    780: {
      items: 2,
    },
    920: {
      items: 4,
    },
  },
};
const Parser = require("html-react-parser");

class Home extends Component {
  constructor(props) {
    super(props);
    const seletedAvilablityId = cookie.load("availability") ?? "";
    const seletedAvilablityName = cookie.load("availabilityName") ?? "";
    this.state = {
      seletedAvilablityId: seletedAvilablityId,
      seletedAvilablityName: seletedAvilablityName,

      openAvailPopup: false,
      loginPopup: false,

      featuredproductList: [],
      newdishesproductList: [],
      bannerList: [],

      selectedPro: "",
      staticblock: [],
      aboutUs: "",
      galleryList: [],
    };
    this.popupRef = createRef();
  }

  componentDidMount() {
    this.loadFeaturedProducts();
    this.loadNewdishesProducts();
    this.loadBanner();
    this.loadGallery();
  }
  componentWillReceiveProps(PropsDt) {
    if (this.state.staticblock !== PropsDt.staticblock) {
      this.setState({ staticblock: PropsDt.staticblock }, () => {
        const aboutUs = this.state.staticblock.find(
          (item) => item?.slug === "home-about-us"
        );
        this.setState({ aboutUs: aboutUs });
      });
    }
  }
  loadBanner() {
    axios
      .get(`${apiUrl}banner/list?uniqueID=${uniqueID}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ bannerList: result });
        }
      })
      .catch(() => {});
  }

  loadGallery() {
    axios
      .get(`${apiUrl}gallery/getlist?uniqueID=${uniqueID}&key=home-gallery`)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          if (result.length > 0) {
            const galleryImages = result[0]?.galleryImages ?? "";
            if (galleryImages !== "" && galleryImages !== null) {
              const galleryList = galleryImages.split(",");
              const finalgalleryList = this.finalgalleryList(galleryList, 3);
              this.setState({ galleryList: finalgalleryList });
            }
          }
        }
      })
      .catch(() => {});
  }

  finalgalleryList = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  loadFeaturedProducts() {
    const deliveryTime = cookie.load("deliveryTime") || '';
    const orderDateTime__ = cookie.load("orderDateTime") || '';
    let orderDate = '';
    if(deliveryTime!=="" && orderDateTime__!=="") {
      orderDate = `${format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd")} ${deliveryTime}`;
    }
    axios
      .get(
        `${apiUrl}products/special-products?uniqueID=${uniqueID}&specialType=featured&orderDate=${orderDate}`
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ featuredproductList: result });
        }
      })
      .catch(() => {});
  }
  loadNewdishesProducts() {
    const deliveryTime = cookie.load("deliveryTime") || '';
    const orderDateTime__ = cookie.load("orderDateTime") || '';
    let orderDate = '';
    if(deliveryTime!=="" && orderDateTime__!=="") {
      orderDate = `${format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd")} ${deliveryTime}`;
    }
    axios
      .get(
        `${apiUrl}products/special-products?uniqueID=${uniqueID}&specialType=newdishes&orderDate=${orderDate}`
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ newdishesproductList: result });
        }
      })
      .catch(() => {});
  }

  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };

  handleClick = (e) => {
    e.preventDefault();
    const target = e.target.closest("[data-id]");
    if (target) {
      const id = target.getAttribute("data-id");
      if (this.state.seletedAvilablityId !== "") {
        this.props.history.push(id);
      } else {
        this.setState({ selectedPro: id, openAvailPopup: true });
      }
    }
  };

  loadProductList(proList) {
    return proList.map((item, index) => {
      return (
        <div
          className="item"
          key={index}
          data-id={`/products/${item.category?.categorySlug}/${item.productSlug}`}
        >
          <div className="product-cover">
            <div className="dish-img">
              <a href="/" className="dish-img-link">
                <img
                  src={item?.productThumbnail || placeholderImage}
                  alt="Thumb"
                />
              </a>
            </div>
            <div className="dish-info">
              <h3 className="dish-name">{item.productName}</h3>
              <p className="dish-price">
                {parseFloat(item.productCost) > 0 && (
                  <span className="strike-price">
                    {showPriceDirect(item.productCost)}
                  </span>
                )}
                {showPriceDirect(item.productPrice)}
              </p>
              <div className="dish-order-btn">
                <a href="/" className="button">
                  Order Now
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  selectAvailability(availability, availabilityName, e) {
    e.preventDefault();
    this.setState({
      seletedAvilablityId: availability,
      seletedAvilablityName: availabilityName,
      popupType: "avalablity",
      openAvailPopup: true,
    });
  }

  render() {
    return (
      <div className="cover">
        <Header
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
          openAvailPopup={this.state.openAvailPopup}
          loginPopup={this.state.loginPopup}
          allowDefaultAvilablity={this.state.seletedAvilablityId}
          allowDefaultAvilablityName={this.state.seletedAvilablityName}
        />
        {this.state.bannerList.length > 0 && (
          <div className="main-slider">
            <OwlCarousel options={mainbanner}>
              {this.state.bannerList.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <img src={item.bannerImage} alt={item.bannerTitle} />
                  </div>
                );
              })}
            </OwlCarousel>
          </div>
        )}
        <div className="home-pick">
          <div className="container">
            <div className="home-picker-inner">
              <ul>
                <li>
                  <a
                    href="/"
                    onClick={this.selectAvailability.bind(
                      this,
                      deliveryId,
                      "Delivery"
                    )}
                  >
                    <figure>
                      <Cycle alt="Delivery" />
                    </figure>
                    <figcaption>Delivery</figcaption>
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={this.selectAvailability.bind(
                      this,
                      pickupId,
                      "Pickup"
                    )}
                  >
                    <figure>
                      <Selficon alt="Takeaway" />
                    </figure>
                    <figcaption>Takeaway</figcaption>
                  </a>
                </li>
                {/* <li>
                  <a href="/">
                    <figure>
                      <img src={dineicon} alt="Dine In" />
                    </figure>
                    <figcaption>Dine In</figcaption>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <figure>
                      <img src={reservation} alt="Reservation" />
                    </figure>
                    <figcaption>Reservation</figcaption>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        {this.state.featuredproductList.length > 0 && (
          <div className="feature-dishes textcenter">
            <div className="container">
              <h2 className="two-color-header">
                Featured <span>Dishes</span>
              </h2>
              <div
                className="dish-slider"
                onClick={this.handleClick.bind(this)}
              >
                <OwlCarousel options={dishslider}>
                  {this.loadProductList(this.state.featuredproductList)}
                </OwlCarousel>
              </div>
            </div>
          </div>
        )}
        {this.state.galleryList.length > 0 && (
          <div className="home-gallery">
            <div className="container">
              <OwlCarousel options={gallery}>
                {this.state.galleryList.map((item, index) => {
                  const firstImage = item[0] ?? "";
                  const secondImage = item[1] ?? "";
                  const thirdImage = item[2] ?? "";
                  return (
                    <div className="gallery-item" key={index}>
                      {firstImage !== "" && (
                        <div className="gallery-item-lhs">
                          <img src={firstImage} alt="burger" />
                        </div>
                      )}
                      <div className="gallery-item-rhs">
                        {secondImage !== "" && (
                          <div className="gir-top">
                            <img src={secondImage} alt="burger" />
                          </div>
                        )}
                        {thirdImage !== "" && (
                          <div className="gir-btm">
                            <img src={thirdImage} alt="burger" />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
          </div>
        )}
        {this.state.aboutUs !== "" && (
          
          <div className="home-about rel">
           <div className="container">
            <div className="home-about-parent">
            <div className="home-about-lhs">
            
              <div className="home-abt-text">
                {Parser(this.state.aboutUs?.description ?? "")}
              </div>
              {appName!=='ajmirbriyani' &&
              <div className="about-reviews textcenter">
                <OwlCarousel options={reviewslider}>
                  <div className="review-item">
                    <div className="quote-img">
                      <img src={quote} alt="burger" />{" "}
                    </div>
                    <div className="testitext">
                      <strong>"Best chirashi bowl in SG!"</strong>
                      <br />
                      I’ve tried a lot of chirashi bowls around Singapore, but
                      Chirashizushi Shou absolutely blew me away. The sashimi
                      was fresh, thick-cut, and super flavorful. You can tell
                      they don’t skimp on quality. I’ll definitely be a regular
                      here!
                      <br />
                      ⭐️⭐️⭐️⭐️⭐️
                    </div>
                    <div className="reviewer-name">— Jasmine T.</div>
                  </div>
                  <div className="review-item">
                    <div className="quote-img">
                      <img src={quote} alt="burger" />{" "}
                    </div>
                    <div className="testitext">
                      <strong>"Great value for amazing quality"</strong>
                      <br />
                      Honestly, I was surprised by how generous the portions
                      were! For the price, I wasn’t expecting such premium
                      ingredients. The rice was seasoned just right and the
                      toppings were on point. Highly recommend for anyone
                      craving real Japanese flavors.
                      <br />
                      ⭐️⭐️⭐️⭐️⭐️
                    </div>
                    <div className="reviewer-name">— Daniel C.</div>
                  </div>
                  <div className="review-item">
                    <div className="quote-img">
                      <img src={quote} alt="burger" />{" "}
                    </div>
                    <div className="testitext">
                      <strong> "Fast, friendly, and super satisfying"</strong>
                      <br />
                      Ordered for pick-up at the Bukit Timah outlet and
                      everything was ready on time, neatly packed, and still
                      fresh when I got home. The staff were polite and helpful,
                      and the food tasted just like something you'd get in
                      Tokyo.
                      <br />
                      ⭐️⭐️⭐️⭐️⭐️
                    </div>
                    <div className="reviewer-name">— Mei L.</div>
                  </div>
                </OwlCarousel>
              </div>
              }
            
            </div>
             <div className="front-hide">
              {this.state.aboutUs?.images && (
                <img
                  src={this.state.aboutUs?.images.split(",")[0]}
                  alt="About Us"
                />
              )}
            </div>
          </div>
          </div>
          </div>
        )}
        {this.state.newdishesproductList.length > 0 && (
          <div className="new-dishes textcenter">
            <div className="container">
              <h2 className="two-color-header">
                New <span>Dishes</span>
              </h2>
              <div
                className="dish-slider"
                onClick={this.handleClick.bind(this)}
              >
                <OwlCarousel options={newdishslider}>
                  {this.loadProductList(this.state.newdishesproductList)}
                </OwlCarousel>
              </div>
            </div>
          </div>
        )}
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var staticblock = "";
  if (Object.keys(state.staticblock).length > 0) {
    if (state.staticblock[0].status === "ok") {
      staticblock = state.staticblock[0].result;
    }
  }
  return {
    staticblock: staticblock,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(Home));
